import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`What is data storage?`}</h2>
    <p>{`Databases store data.`}</p>
    <h2>{`Key open source projects`}</h2>
    <ul>
      <li parentName="ul">{`MySQL`}</li>
      <li parentName="ul">{`MongoDB`}</li>
    </ul>
    <h2>{`Why do databases matter in an open source cloud?`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "36.11111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABPUlEQVQoz3VRTUvDQBDtb/Wf6MmTJ89evXgRKUUEP6qXRA2FluIhlXw2aT6aNslmk23T585CC6n6YHg7y+ybebO93W4HQpqmsG0bruvCcRzMZjNYlgXTNGHLPAhDde/5vqxz4EumWnpHIB2K3l6Qc44gCBDKh8SuY2OZJogWoeJsmWIRztU9ZyU2GwHGGJqm+S24F12tVvA8V032oo3w/DHF0/sEj/pYnR+0MfrDT+hTS9b5EEIcxPY4TLjdbhFFkbJB1k+vhzi70XFxZ+D81sDVQMNo8oWkqBEka1V7PF3HMjHZ9T0P5reFk8s+Bm8G1iXDuhLgzQb/4c8Jicky7cry5rh/1cHyDHXNUfNK7rhCUZYoZYOiIC7VDtu27Yj2jjsQhGhQ5Dky2SBJEvWTFHTOsgxxHCumvKqqjuAP3b0Qgu1AEKMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "survey results",
        "title": "survey results",
        "src": "/static/350e058c9cdbdbe7489fec51b4e98cb9/3cbba/survey-databases.png",
        "srcSet": ["/static/350e058c9cdbdbe7489fec51b4e98cb9/7fc1e/survey-databases.png 288w", "/static/350e058c9cdbdbe7489fec51b4e98cb9/a5df1/survey-databases.png 576w", "/static/350e058c9cdbdbe7489fec51b4e98cb9/3cbba/survey-databases.png 1152w", "/static/350e058c9cdbdbe7489fec51b4e98cb9/0b124/survey-databases.png 1728w", "/static/350e058c9cdbdbe7489fec51b4e98cb9/4ea69/survey-databases.png 2304w", "/static/350e058c9cdbdbe7489fec51b4e98cb9/18798/survey-databases.png 2498w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Cloud comparison`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`IBM Cloud`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GCP`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`AWS`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Azure`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cloudant`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`MySQL`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`SQL`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      